import { makeStyles } from 'tss-react/mui';
const drawerWidth = 340;
const subDrawerWidth = 300;

export const useStyles = makeStyles()(
  (theme) => ({
    title: {
      flexGrow: 1,
      // marginLeft: '6%',
      marginLeft: 65,
    },
    rotateIcon: {
      animation: "$spin 2s linear infinite"
    },
    "@keyframes spin": {
      "0%": {
        transform: "rotate(180deg)"
      },
      "100%": {
        transform: "rotate(180deg)"
      }
    },
    timezone: {
      fontSize: '16px',
      color: '#FFFFFF',
      marginLeft: '5px',
    },
    layout: {
      display: 'grid',
      flexDirection: 'column',
      gridTemplateColumns: `auto 1fr`,
      gridTemplateRows: '60px auto',
    },
    appBar: {
      gridRow: '1 / 2',
      gridColumn: '2 / 3',
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      gridRow: '1',
      gridColumn: '2',
      paddingLeft: `calc(${drawerWidth - 65}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    appBarShiftSubDrawer: {
      gridRow: '1',
      gridColumn: '2',
      paddingLeft: `calc(${subDrawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    appBarShiftDrawers:{
      gridRow: '1',
      gridColumn: '2',
      paddingLeft: `calc(${(subDrawerWidth + drawerWidth) - 65}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    searchIcon: {
      marginLeft: theme.spacing(2),
    },
    logoBox: {
      gridColumn: '1',
      gridRow: '1',
      backgroundColor: theme.palette.background.paper,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderBottom: 'solid 0.5px #eaeaea',
    },
    logoImage:{
      width: 180,
      verticalAlign: 'middle',
    },
    collapseIcon: {
      '& path':{
        fill:'#757575',
      },
      fill:'#757575',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fontSize: '1.5rem',
      transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      flexShrink: 0,
      userSelect: 'none',
    },
    menuList: {
      gridColumn: '1',
      gridRow: '2 / -1',
      width: '100%',
      backgroundColor: theme.palette.background.paper,
      borderRight: 'solid 0.5px #eaeaea',
    },
    content: {
      gridRow: '2 / -1',
      gridColumn: '2 / -1',
      backgroundColor: '#fafafa!important',
      // marginLeft: theme.spacing(9) + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    contentShift: {
      gridRow: '2 / -1',
      gridColumn: '2 / -1',
      backgroundColor: '#fafafa!important',
      // marginLeft: drawerWidth,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    contentShiftSubDrawer: {
      gridRow: '2 / -1',
      gridColumn: '2 / -1',
      paddingLeft: `calc(${subDrawerWidth}px)`,
      backgroundColor: '#fafafa!important',
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawer: {
      minHeight: '100vh',
      flexShrink: 0,
      whiteSpace: 'nowrap',
      gridRow: '1 / -1',
      gridColumn: '1',
    },
    drawerOpen: {
      overflowX: 'hidden',
      minHeight: '100vh',
      gridColumn: '1',
      gridRow: '1 / -1',
      width: drawerWidth,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerClose: {
      gridColumn: '1',
      gridRow: '1 / -1',
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      overflowX: 'hidden',
      width: theme.spacing(7) + 1,
      [theme.breakpoints.up('sm')]: {
        width: theme.spacing(9) + 1,
      },
    },
    avatarBorder: {
      border: '2px solid #4771b1',
    },
    chevronIcon: {
      display: 'flex',
      // justifyContent: (props: any) => (props.open ? 'flex-end' : 'center'),
      padding: theme.spacing(0, 1),
      marginBottom: theme.spacing(2),
      marginTop: 'auto',
    },
    toolBar: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    hr: {
      height: '44px',
      margin: '0px 12px',
      alignSelf: 'center',
      border: '1px solid #3b6c95',
    },
    subMenuDrawer: {
      width: drawerWidth,
      flexShrink: 0,
      marginLeft: drawerWidth,
      paddingLeft: drawerWidth,
  },
  drawerPaper: {
      width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    // padding: theme.spacing(0, 1),
    paddingLeft: 26,
    // necessary for content to be below app bar
    //Styling Issue Temp Fix
    // ...theme.mixins.toolbar,
    // justifyContent: 'flex-end',
  },
  subMenuListItem: {
    paddingLeft: '0!important',
    paddingRight: '0!important',
  },
  subMenuTitle:{
    fontSize: '1.125rem',
  },
  backIcon:{
    marginRight: '2px!important',
  },
  backButton: {
    marginTop : '10px!important',
    padding: '0!important',
    color: '#5C6571!important',
  },
  }))
  // {
  //   name: 'Layout',
  // },
  // };
